import React from "react";
import ReactApexChart from "react-apexcharts";

export default function MergersAcquisitionsVisual({ name, data }) {
  const series = [
    {
      name: name,
      data: data,
    },
  ];

  const options = {
    theme: {
      mode: "dark",
    },
    legend: {
      show: false,
    },
    chart: {
      height: 400,
      type: "treemap",
    },
    title: {
      text: name,
      align: "center",
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "15px",
      },
      formatter: function (text, op) {
        return [text, op.value];
      },
    },
  };

  return (
    <>
      <ReactApexChart
        options={options}
        series={series}
        type="treemap"
        height={400}
      />
    </>
  );
}
